<script setup>
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();
const sortBy = computed(() => store.getters['untrackedKeywords/sortBy']);
const sortDirection = computed(() => store.getters['untrackedKeywords/sortDirection']);
</script>

<template>
  <div class="-tw-mx-8 tw-border-y tw-border-grey-mid">
    <div class="tw-grid tw-grid-cols-12 tw-px-10 tw-divide-x tw-divide-grey-mid tw-min-h-12">
      <div
        class="tw-col-span-3 tw-py-2 tw-flex tw-items-center tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'keyword')"
      >
        Keyword
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'keyword' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'keyword',
          }"
        />
      </div>
      <div
        class="tw-col-span-1 tw-pl-2 tw-py-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'position')"
      >
        Position
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'position' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'position',
          }"
        />
      </div>
      <div
        class="tw-col-span-1 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'search_volume')"
      >
        Search Volume
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'search_volume' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'search_volume',
          }"
        />
      </div>
      <div
        class="tw-col-span-1 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'difficulty')"
      >
        Keyword Difficulty
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'difficulty' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'difficulty',
          }"
        />
      </div>
      <div
        class="tw-col-span-3 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'url')"
      >
        URL
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'url' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'url',
          }"
        />
      </div>
      <div
        class="tw-col-span-2 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark"
        @click="store.dispatch('untrackedKeywords/sortBy', 'last_checked')"
      >
        Last Checked
        <svg-vue
          icon="icons/chevron"
          class="tw-flex tw-flex-shrink-0 tw-w-2 tw-h-2 tw-ml-3 tw-transition-transform duration-500 group-hover:tw-text-blue-dark"
          :class="{
            'tw-rotate-180': sortBy === 'last_checked' && sortDirection === 'asc',
            'tw-text-blue': sortBy === 'last_checked',
          }"
        />
      </div>
      <div class="tw-col-span-1 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-text-grey-dark" />
    </div>
  </div>
</template>
